module.exports = __webpack_public_path__ + "static/media/happydogSS.1dc432c9.jpg";